/*

 */

// TODO: Why do we call them events here but actions elsewhere? - Rename for consistency
export const APP_EVENT_CLEAR_ALL = 'APP:CLEAR_ALL';
export const APP_EVENT_SET_LOGGED_OUT = 'APP:SET_LOGGED_OUT';
